import React from 'react';

// Smittnik — a visual drop zone shaped like a trash bin. The bin itself is a
// fixed slide element; movable elements that students drag over it keep their
// dropped position (persisted by the generic student-drag pipeline), so items
// visually "stay inside" the bin without any special state on this element.
const SmittnikElement = ({ element }) => {
  const content = element.content || {};
  const bodyColor = content.bodyColor || '#2A4D25';
  const lidColor = content.lidColor || content.bodyColor || '#2A4D25';
  const accentColor = content.accentColor || '#ffffff';

  return (
    <div className="w-full h-full relative pointer-events-none select-none">
      <svg
        viewBox="0 0 100 120"
        preserveAspectRatio="xMidYMid meet"
        className="w-full h-full block"
        aria-hidden="true"
      >
        {/* Handle on top of the lid */}
        <rect x="38" y="8" width="24" height="6" rx="3" fill={lidColor} />
        {/* Lid */}
        <rect x="8" y="16" width="84" height="12" rx="4" fill={lidColor} />
        {/* Body */}
        <path
          d="M 14 32 L 86 32 L 80 112 Q 79 118 73 118 L 27 118 Q 21 118 20 112 Z"
          fill={bodyColor}
        />
        {/* Vertical ribs */}
        <line x1="38" y1="42" x2="35" y2="108" stroke={accentColor} strokeWidth="2.5" strokeLinecap="round" opacity="0.55" />
        <line x1="50" y1="42" x2="50" y2="108" stroke={accentColor} strokeWidth="2.5" strokeLinecap="round" opacity="0.55" />
        <line x1="62" y1="42" x2="65" y2="108" stroke={accentColor} strokeWidth="2.5" strokeLinecap="round" opacity="0.55" />
      </svg>
    </div>
  );
};

export default SmittnikElement;
